import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {Switch} from 'src/design/atoms/Switch';
import {Text} from 'src/design/atoms/Text';
import {IconWifi, IconWifiOff} from '@tabler/icons-react';
import React from 'react';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {setSimulatedOffline} from 'src/offline/connectivity';
import {useConnectivity} from 'src/offline/useConnectivity';

export const ConnectivityCard: React.FC = () => {
  const {isOffline, isSimulated} = useConnectivity();

  return (
    <SectionCard
      title="Connectivity"
      icon={isOffline ? <IconWifiOff size={14} /> : <IconWifi size={14} />}
      iconColor={isOffline ? 'red' : 'green'}>
      <Stack p="md" gap="sm">
        <Group gap="xs">
          <Text size="sm">Status:</Text>
          <Text size="sm" fw={600} c={isOffline ? 'red' : 'green'}>
            {isOffline ? 'Offline' : 'Online'}
            {isSimulated ? ' (simulated)' : ''}
          </Text>
        </Group>
        <Switch
          label="Simulate offline"
          description="Real offline testing = devtools network throttling. This flag drives the app's offline behavior identically, without needing devtools."
          checked={isSimulated}
          onChange={event => setSimulatedOffline(event.currentTarget.checked)}
        />
      </Stack>
    </SectionCard>
  );
};
